import { render, staticRenderFns } from "./downbtn.vue?vue&type=template&id=7f9855ff&scoped=true"
import script from "./downbtn.vue?vue&type=script&lang=js"
export * from "./downbtn.vue?vue&type=script&lang=js"
import style0 from "./downbtn.vue?vue&type=style&index=0&id=7f9855ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9855ff",
  null
  
)

export default component.exports